import { log } from '../../services/utils';

import { controller } from '../../contexts/CalendarContext';

import { noraApiRequest } from './';

export const getCalendarEvents = async (
	start = new Date( new Date().setDate( new Date().getDate() - 60 ) ).toISOString(), // 60 days
	end = new Date().toISOString()
) => {
	log( '* get calendar events' );
	const { data } = await noraApiRequest( {
		url: '/calendar/events',
		params: {
			start,
			end
		},
		signal: controller.signal
	} );

	return data;
};

export const getCalendarEvent = async id => {
	log( '* get calendar event' );
	const { data } = await noraApiRequest( {
		url: `/calendar/events/${ id }`,
		signal: controller.signal
	} );

	return data;
};

export const getEventTags = async () => {
	log( '* get event tags' );
	const { data } = await noraApiRequest( {
		url: '/calendar/labels',
		signal: controller.signal
	} );

	return data;
};
